import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import ReportViewer, {
  accountxReportUrl,
} from 'containers/DigitalReportModule/ReportViewer'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'

export const GLJournalListingByDepartmentWithBalancesReport = () => {
  const history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const accountID = user.accountID
  let location = useLocation()
  const editData = location?.state as any
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const parameters = [
    { name: 'accountid', value: accountID },
    { name: 'companyid', value: editData?.CompanyID },
    {
      name: 'startdate',
      value: new Date(editData?.StartDate.setHours(0, 0, 0)).toISOString(),
    },
    {
      name: 'enddate',
      value: new Date(editData?.EndDate.setHours(0, 0, 0)).toISOString(),
    },
    { name: 'fyear', value: editData?.Year },
    { name: 'fperiod', value: editData?.Period },
    { name: 'accountcode', value: editData?.AccountCode },
    { name: 'journaltype', value: editData?.JournalType },
    { name: 'journalno', value: editData?.JournalNo },
    { name: 'accountname', value: editData?.AccountName },
    { name: 'remark', value: editData?.Description },
    { name: 'costcentrecode', value: editData?.CostCentreCode },
    { name: 'referenceno', value: editData?.ReferenceNo },
  ]

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&'
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value
    })
    return reporturl
  }

  return (
    <>
      <MainHeader
        onClick={() => history.push(`/digital-reports/general-ledger`)}
        mainBtn="close"
        smTitle="General Ledger"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Digital Reporting' },
          {
            name: 'GL Journal Listing By Department With Balances',
            current: true,
          },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl(
            'GLJournalListingByDepartmentWithBalances',
            parameters
          ),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
